import styleButton from '../../../../../../shared/components/rbh-button/styles';
import { Colors } from '../../../../../../shared/theme';
import { textStyles } from '../../../../../../shared/theme/fonts-ppv';


export default {
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '16px',
        height: '56px'
    } as React.CSSProperties,
    headerText: {
        ...textStyles.h4
    },
    titleSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    buttonAdd: {
        ...styleButton,
        ...textStyles.subtitle2,
        color: Colors.white,
        borderRadius: '24px',
        borderColor: Colors.violet,
        background: Colors.violet,
    },
    addAndSearchSection: {
        display: 'flex',
        gap: '16px',
        alignItems: 'center'
    },
    search: {
        width: '240px',
        borderColor: '#EDEDF5',
        borderRadius: '8px'
    },
    searchIcon: {
        color: '#9597BD'
    },
    sortingSection: {
        display: 'flex',
        cursor: 'pointer',
        gap: '2px'
    },
    pill: {
        width: '28px',
        height: '20px',
        textAlign: 'center',
        borderRadius: '24px',
        color: Colors.white,
        backgroundColor: '#6D709B'
    },
    ActionSection: {
        display: 'flex',
        gap: '16px',
        alignItems: 'center'
    }
}